import moment from 'moment';

export function setMomentLocale(locales) {
  if (!locales?.date) return;
  const monthKeys = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ];
  const months = monthKeys.map((key) => locales.date[key]?.name || '');
  const monthsShort = monthKeys.map(
    (key) => locales.date[key]?.nameShort || '',
  );
  moment.updateLocale('en', {
    months,
    monthsShort,
  });
  moment.locale('en');
}
